module Meevo.Components.Controls.SmartMover {
    import ClientType = Model.ClientClientType;

    export class ClientTypeCollection extends SmartMoverApiCollection<ClientType> implements IApiCollection<ClientType> {
        get url() {
            return 'clientClientType';
        }
    }
}
